import React from 'react';
import Section from '../Section';
import Button from '../Button';
import GradualSpacingText from '../GradualSpacingText/GradualSpacingText';
import './WaitlistCTA.css';

const WaitlistCTA = ({ onJoinClick }) => {
    return (
        <Section 
            className="waitlist-section reveal"
            style={{ 
                backgroundImage: `url(${process.env.PUBLIC_URL}/assets/images/demo.png)` 
            }}
        >
            <div className="waitlist-content">
                <h2 className="section-headline">
                    Get the capacity you need
                </h2>
                <p className="exclusivity-text">
                    Whether you need a single truck or dedicated lanes, we provide reliable dry-van transportation and flexible freight solutions.
                </p>
                <div style={{ textAlign: 'center', marginTop: 18 }}>
                    <Button onClick={onJoinClick} variant="primary" className="secure-spot">Request Quote</Button>
                </div>
            </div>
        </Section>
    );
};

export default WaitlistCTA;